import { useEffect, useState } from "react";

// Component and CSS map
const componentMap = {
    "Countdown_Timer_Temp": {
        component: () => import("./CountdownTimerWidget"),
        cssFile: `${process.env.PUBLIC_URL}/countdown-timer/temp-css/CountdownTimerWidget.css`, 
    },
    "Black_Friday_Sale_Banner_Temp": {
        component: () => import("./BlackFridaySaleBannerWidget"),
        cssFile: `${process.env.PUBLIC_URL}/countdown-timer/temp-css/BlackFridaySaleBannerWidget.css`,  
    },
    "Special_Offer_Banner_Temp": {
        component: () => import("./SpecialOfferBannerWidget"),
        cssFile: `${process.env.PUBLIC_URL}/countdown-timer/temp-css/SpecialOfferBannerWidget.css`,
    },
    "Urgency_Countdown_Temp": {
        component: () => import("./UrgencyCountdownWidget"),
        cssFile: `${process.env.PUBLIC_URL}/countdown-timer/temp-css/UrgencyCountdownWidget.css`,
    },
    "Event_Start_Countdown_Temp": {
        component: () => import("./EventStartCountdownWidget"),
        cssFile: `${process.env.PUBLIC_URL}/countdown-timer/temp-css/EventStartCountdownWidget.css`,
    },
    "Limited_Shipping_Banner_Temp": {
        component: () => import("./LimitedShippingBannerWidget"),
        cssFile: `${process.env.PUBLIC_URL}/countdown-timer/temp-css/LimitedShippingBannerWidget.css`,
    },
};

const DynamicTemplate = ({ selectedTemplate, layoutType, isTemplateId, widgetId, countdownTimerTabData }) => {
    const [TemplateComponent, setTemplateComponent] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const loadTemplate = async () => {
            const template = componentMap[selectedTemplate];

            if (!template) {
                setTemplateComponent(null);
                return;
            }

            // Remove all previous template stylesheets
            document
            .querySelectorAll(`link[data-dynamic-css]`)
            .forEach((link) => link.remove());

            // If template has a CSS file, wait for it to load
            if (template.cssFile) {
                await new Promise((resolve, reject) => {
                    const link = document.createElement("link");
                    link.rel = "stylesheet";
                    link.href = template.cssFile;
                    if (widgetId) {
                        link.setAttribute("countdown-timer-data-dynamic-css", selectedTemplate);
                    } else {
                        link.setAttribute("data-dynamic-css", selectedTemplate);
                    }
                    link.onload = () => resolve();
                    link.onerror = () => reject(new Error("Failed to load CSS"));

                    document.head.appendChild(link);
                });
            }

            if (isMounted) {
                const componentModule = await template.component();
                setTemplateComponent(() => componentModule.default);
            }
        };

        loadTemplate().catch((err) => {
            setTemplateComponent(null);
        });

        return () => {
            isMounted = false;
        };
    }, [selectedTemplate,widgetId]);


    if (!TemplateComponent)
    return (
        <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading please wait...</p>
        </div>
    );

    return (
        <TemplateComponent
            selectedTemplate={selectedTemplate} selectedLayout={layoutType} isTemplateId={isTemplateId} widgetId={widgetId}
            countdownTimerTabData={countdownTimerTabData}
        />
    );
};

export default DynamicTemplate;
